module.exports = __webpack_public_path__ + "static/img/04.f729f5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour2/04.jpg
// module id = ndQN
// module chunks = 0